import styled from '@emotion/styled';
import {mixinFocus} from 'webapp-lib/styling';

/** @deprecated Use EFilter instead. */
export const StyledItem = styled.button<{active?: boolean}>`
  display: flex;
  align-items: center;
  border: unset;
  padding: 2px var(--gutter-little);
  height: 24px;
  width: fit-content;
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-thin);
  cursor: pointer;
  user-select: none;
  color: ${({active}): string =>
    active ? 'var(--color-core-black)' : 'var(--color-core-link)'};
  background-color: ${({active}): string =>
    active ? 'var(--color-state-active)' : 'var(--color-core-white)'};

  :focus {
    ${mixinFocus}
  }
`;
